import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/displayToggle/toggleButton/styles.scss';export default {
  "toggleButton": "_toggleButton_1yxhc_1",
  "thumb": "_thumb_1yxhc_10",
  "active": "_active_1yxhc_21",
  "right": "_right_1yxhc_25",
  "activeButton": "_activeButton_1yxhc_29",
  "row": "_row_1yxhc_34",
  "label": "_label_1yxhc_46",
  "icon": "_icon_1yxhc_53",
  "selected": "_selected_1yxhc_61",
  "disable": "_disable_1yxhc_68"
};